<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'

    export let disabled = false

    const dispatch = createEventDispatcher<{ change: string | null }>()

    let canvasEl: HTMLCanvasElement
    let drawing = false
    let hasSignature = false

    onMount(() => {
        const ctx = canvasEl.getContext('2d')
        if (!ctx) return
        ctx.strokeStyle = '#212529'
        ctx.lineWidth = 2
        ctx.lineCap = 'round'
    })

    function pointerDown(event: PointerEvent) {
        if (disabled) return
        drawing = true
        const ctx = canvasEl.getContext('2d')
        const rect = canvasEl.getBoundingClientRect()
        ctx?.beginPath()
        ctx?.moveTo(event.clientX - rect.left, event.clientY - rect.top)
    }

    function pointerMove(event: PointerEvent) {
        if (disabled || !drawing) return
        const ctx = canvasEl.getContext('2d')
        const rect = canvasEl.getBoundingClientRect()
        ctx?.lineTo(event.clientX - rect.left, event.clientY - rect.top)
        ctx?.stroke()
        hasSignature = true
    }

    function pointerUp() {
        if (disabled || !drawing) return
        drawing = false
        dispatch('change', canvasEl.toDataURL('image/png'))
    }

    function clear() {
        if (disabled) return
        const ctx = canvasEl.getContext('2d')
        ctx?.clearRect(0, 0, canvasEl.width, canvasEl.height)
        hasSignature = false
        dispatch('change', null)
    }
</script>

<div class="sign-pad">
    <canvas
        bind:this={canvasEl}
        width="360"
        height="140"
        class="sign-canvas"
        class:readonly={disabled}
        on:pointerdown={pointerDown}
        on:pointermove={pointerMove}
        on:pointerup={pointerUp}
        on:pointerleave={pointerUp}
    />
    <button type="button" class="sign-clear" on:click={clear} disabled={!hasSignature || disabled}>Limpar assinatura</button>
</div>

<style>
    .sign-canvas {
        display: block;
        width: 360px;
        height: 140px;
        border: 1px dashed #ced4da;
        border-radius: 8px;
        background: #fbfbfc;
        touch-action: none;
        cursor: crosshair;
    }
    .sign-canvas.readonly {
        cursor: not-allowed;
        opacity: 0.7;
    }
    .sign-clear {
        margin-top: 8px;
        border: none;
        background: transparent;
        color: #868e96;
        font-size: 0.8rem;
        padding: 4px 0;
        cursor: pointer;
    }
    .sign-clear:hover:not(:disabled) {
        color: var(--cs2-accent, #1bdf6f);
    }
    .sign-clear:disabled {
        cursor: default;
        opacity: 0.5;
    }
</style>
